import { getDefaultExportFromCjs as d } from "../../../_virtual/_commonjsHelpers.js";
import { __module as r } from "../../../_virtual/index2.js";
import "./components/Modal.js";
import { __exports as f } from "../../../_virtual/Modal.js";
(function(o, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = f, l = u(a);
  function u(e) {
    return e && e.__esModule ? e : { default: e };
  }
  t.default = l.default, o.exports = t.default;
})(r, r.exports);
var i = r.exports;
const n = /* @__PURE__ */ d(i);
export {
  n as default
};
